export default "__VITE_ASSET__DML3Efa7__"